export const FETCH_VENUES_REQUEST = "FETCH_VENUES_REQUEST";
export const FETCH_VENUES_SUCCESS = "FETCH_VENUES_SUCCESS";
export const FETCH_VENUES_FAILURE = "FETCH_VENUES_FAILURE";

export const FETCH_VENUES_DETAILS_REQUEST = "FETCH_VENUES_DETAILS_REQUEST";
export const FETCH_VENUES_DETAILS_SUCCESS = "FETCH_VENUES_DETAILS_SUCCESS";
export const FETCH_VENUES_DETAILS_FAILURE = "FETCH_VENUES_DETAILS_FAILURE";

export const FETCH_BOOKINGS_REQUEST = "FETCH_BOOKINGS_REQUEST";
export const FETCH_BOOKINGS_SUCCESS = "FETCH_BOOKINGS_SUCCESS";
export const FETCH_BOOKINGS_FAILURE = "FETCH_BOOKINGS_FAILURE";

export const FETCH_BOOKED_STATUS_REQUEST = "FETCH_BOOKED_STATUS_REQUEST";
export const FETCH_BOOKED_STATUS_SUCCESS = "FETCH_BOOKED_STATUS_SUCCESS";
export const FETCH_BOOKED_STATUS_FAILURE = "FETCH_BOOKED_STATUS_FAILURE";  